// extracted by mini-css-extract-plugin
export default {"error_container":"SelectTranslationPopup_error_container__3qkMX","error_text":"SelectTranslationPopup_error_text__mCgS9"};